import api from "./Api";

class ClienteEmailService {
  GetClienteEmail(payload) {
    return api.get("/v1/clienteEmail/" + payload).then((response) => {
      return response.data;
    });
  }

  PostClienteEmail(payload) {
    return api.post("/v1/clienteEmail/", payload).then((response) => {
      return response.data;
    });
  }

  PutClienteEmail(payload) {
    return api.put("/v1/clienteEmail/", payload).then((response) => {
      return response.data;
    });
  }

  DeleteClienteEmail(payload) {
    return api.delete("/v1/clienteEmail/" + payload).then((response) => {
      return response.data;
    });
  }

  GetClienteEmailOData(payload) {
    return api.get("/OData/ClienteEmail" + payload).then((response) => {
      return response.data;
    });
  }
}

export default new ClienteEmailService();
